import React from "react";

export default function Loading() {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gray-100 z-0">
      {/* Loader Animation */}
      <div className="relative w-24 h-24 flex items-center justify-center">
        <div className="absolute w-24 h-24 border-8 border-t-indigo-500 border-b-indigo-300 border-l-transparent border-r-transparent rounded-full animate-spin"></div>
      </div>
      {/* Loading Text */}
      <h1 className="mt-6 text-2xl font-semibold text-gray-700 tracking-wide">
        Carregando...
      </h1>
      {/* Subtle Text Animation */}
      <p className="text-gray-500 mt-2 text-sm animate-pulse">
        Por favor, aguarde um momento.
      </p>
    </div>
  );
}
